// Rules for the shared list pager (Roadmap 1867: every long list pages like
// the Work page: "Showing 21–40 of 510", arrows and up to 5 page numbers).

/** "Showing 21–40 of 510" (or `emptyLabel` when there is nothing). */
export const pageLabel = (
  page: number,
  pageSize: number,
  total: number,
  emptyLabel = "No items",
) => {
  if (!total) return emptyLabel;
  const first = Math.min(total, (page - 1) * pageSize + 1);
  const last = Math.min(total, page * pageSize);
  return `Showing ${first}–${last} of ${total}`;
};

/** Number of pages for a total (at least 1). */
export const pageCount = (total: number, pageSize: number) =>
  Math.max(1, Math.ceil((total || 0) / Math.max(1, pageSize)));

/** Up to `max` page numbers around the current page, e.g. 3 4 [5] 6 7. */
export const visiblePages = (page: number, totalPages: number, max = 5) => {
  if (totalPages < 1) return [];
  const first = Math.max(
    1,
    Math.min(page - Math.floor(max / 2), totalPages - max + 1),
  );
  const last = Math.min(totalPages, first + max - 1);
  return Array.from({ length: last - first + 1 }, (_, i) => first + i);
};
